const shopGroupPageCarousel = {
  displayField: 'headline',
  name: 'Shop Group Page Carousel',
  description: '',
  fields: [
    {
      id: 'headline',
      name: 'headline',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'shopGroupPageCarousel',
    version: 10,
    updatedAt: '2023-08-03T14:30:47.245Z'
  }
};
export default shopGroupPageCarousel;